// @flow

import generateConfig from "./generator";

const env = process.env;
const config = generateConfig(env);

export default config;
export * from "./type";
